/* unplugin-vue-components disabled */import { render } from "./address-box.vue?vue&type=template&id=12dd7cac"
import script from "./address-box.vue?vue&type=script&lang=js"
export * from "./address-box.vue?vue&type=script&lang=js"

import "./address-box.vue?vue&type=style&index=0&id=12dd7cac&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__